import { render } from "./RegistOneClass.vue?vue&type=template&id=851cc5c8&scoped=true"
import script from "./RegistOneClass.vue?vue&type=script&lang=js"
export * from "./RegistOneClass.vue?vue&type=script&lang=js"

import "./RegistOneClass.vue?vue&type=style&index=0&id=851cc5c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-851cc5c8"]])

export default __exports__